import { observer } from 'mobx-react'
import React, { FC } from 'react'
import { HelpCircle } from 'react-feather'

import { Avatar } from '@avantstay/backoffice-core'
import { IconLogOut } from '@avantstay/backoffice-vectors'

import * as S from './AvatarDropdown.styles'
import { AvatarDropdownProps } from './types'

export const AvatarDropdown: FC<AvatarDropdownProps> = observer(
  ({ userPhoto, signOut, onHelp, userName, userEmail }) => {
    return (
      <S.Container>
        <S.User>
          <span>
            <Avatar src={userPhoto} />
            <span>
              <S.UserName>{userName}</S.UserName>
              <S.UserEmail>{userEmail}</S.UserEmail>
            </span>
          </span>
        </S.User>
        <S.MenuBtn onClick={onHelp}>
          <HelpCircle width={16} />
          Help
        </S.MenuBtn>
        <S.LogoutBtn onClick={signOut}>
          <IconLogOut width={16} />
          Log out
        </S.LogoutBtn>
      </S.Container>
    )
  },
)
